import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { FeatureGrid } from '../components/sections/FeatureGrid';
import { BonusSection } from '../components/sections/BonusSection';
import { SocialProof } from '../components/sections/SocialProof';
import { PriceBlock } from '../components/sections/PriceBlock';
import { FAQSection } from '../components/sections/FAQSection';
import { PurchasePopup } from '../components/ui/PurchasePopup';
export function SalesPage() {
  return <main className="min-h-screen bg-bg text-text-primary selection:bg-accent/30 selection:text-accent overflow-x-hidden" data-id="element-222">
      <HeroSection data-id="element-223" />
      <ProblemSection data-id="element-224" />
      <SolutionSection data-id="element-225" />
      <FeatureGrid data-id="element-226" />
      <BonusSection data-id="element-227" />
      <PriceBlock data-id="element-228" />
      <SocialProof data-id="element-229" />
      <FAQSection data-id="element-230" />

      {/* Footer */}
      <footer className="bg-bg border-t border-border py-8 text-center" data-id="element-231">
        <p className="font-body text-sm text-text-secondary" data-id="element-232">
          © {new Date().getFullYear()} Arquitectura Mental de Influencia. Todos
          los derechos reservados.
        </p>
      </footer>

      {/* Purchase notification popup */}
      <PurchasePopup data-id="element-233" />
    </main>;
}